import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  // fetchThemeSaga,
  fetchThemeSuccess,
  fetchThemeFailure,
  createThemeSuccess,
  createThemeFailure,
} from './AppThemeSlice';

import {
  fetchThemeRequest,
  createThemeRequest,
} from './AppThemeSlice'; // for takeLatest triggers

// FETCH THEME
function* fetchThemeSaga() {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/app-theme/get-theme-dashboard`
    );


    if (response.data.success) {
      yield put(fetchThemeSuccess(response.data.data)); 
    } else {
      yield put(fetchThemeFailure(response.data.message || "Failed to get theme."));
    }
  } catch (error) {
    yield put(fetchThemeFailure(error.response?.data?.message || error.message));
  }
}

// CREATE / UPDATE THEME
function* createThemeSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/app-theme/create-app-theme`,
      action.payload
    );
    if (response.data.success) {
      yield put(createThemeSuccess(response.data.data));
    } else {
      yield put(createThemeFailure(response.data.message || "Failed to create theme."));
    }
  } catch (error) {
    yield put(createThemeFailure(error.response?.data?.message || error.message));
  }
}

// ROOT THEME SAGA
export function* AppThemeSaga() {
  yield takeLatest(fetchThemeRequest.type, fetchThemeSaga);
  yield takeLatest(createThemeRequest.type, createThemeSaga);
}